import styled from 'styled-components';
import { Button, ModalHeader } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 16px;
  width: 100%;
  left: 0px;
  top: 104px;
  background: #f9f9fb;
  flex-wrap: wrap;
  order: 3;
  margin: 0px 10px;
  max-height: 70vh;
  overflow-y: hidden;

  &:hover {
    overflow-y: scroll;

    > section {
      width: 100%;
    }

    &::-webkit-scrollbar-track {
      -webkit-box-shadow: none !important;
      background-color: transparent !important;
    }

    &::-webkit-scrollbar {
      width: 6px !important;
      background-color: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #acacac;
    }
  }
`;

export const StyledUploadButton = styled(Button)`
  border: 1px solid #dfe3ec;
  box-sizing: border-box;
  border-radius: 4px;
  margin-left: 16px;
`;

export const StyledCloseButton = styled(Button)`
  border: 1px solid #dfe3ec;
  box-sizing: border-box;
  border-radius: 4px;
  margin-left: 16px;
`;

export const StyledJustifyRight = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const StyledModalHeader = styled(ModalHeader)`
  .modal-title {
    width: 100%;
  }
  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  h5 {
    font-weight: 500;
    font-size: 22px;
    line-height: 32px;
    color: #33373d;
  }

  p {
    font-weight: lighter;
    font-size: 16px;
    margin-bottom: 0px;
    color: #6e7582;
  }

  padding-bottom: 0px;
  border-bottom: none;
`;

export const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
  margin-right: 8px;
`;
